<template>
  <div class="menu-options d-flex align-items-center h-100">
    <div class="wrapper">
      <div class="discover cursor-pointer" @click="discoverClick">
        <span :style="{ color: getHeaderTextColor }" class="text font-weight-light">{{
          $t('main.header.tags.discover')
        }}</span>
        <div class="discover-icon">
          <img
            src="https://cdn.vexels.com/img/menu-icon.svg"
            :alt="$t('main.header.tags.discoverIconAlt')"
            width="4"
            height="20"
          />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';

export default {
  computed: {
    ...mapGetters('config', ['getHeaderTextColor'])
  },
  methods: {
    discoverClick() {
      this.$ga.event('Top Menu', 'Click Discover Button Top Menu', this.$route.fullPath);
      this.$bvModal.show('discover-modal');
    }
  }
};
</script>

<style lang="scss" scoped>
.discover {
  &:focus {
    outline: none;
  }
  @include lg {
    .text {
      display: none;
    }
  }
}
.discover {
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 16px;
}
.discover-icon {
  height: 20px;
  object-fit: cover;
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
}
.menu-options {
  display: flex;
  justify-content: flex-end;
  align-items: center;
  font-weight: 400;
  color: $mediumDarkGray;
  padding-left: 10px;
  @include md {
    .link {
      display: none;
    }
  }
}
.mobile-menu {
  display: none;
  @include sm {
    display: block;
  }
}
.wrapper {
  display: flex;
  align-items: center;
  justify-content: center;
}
</style>
